exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".GridItem-246eeb87{text-align:center}.GridItem-246eeb87 .value-5240eda6{font-size:26px;font-weight:600;margin:0 0 20px 0}\n", ""]);

// Exports
exports.locals = {
	"GridItem": "GridItem-246eeb87",
	"value": "value-5240eda6"
};